export function pathToPageName(path: string) {
  const pageName = `legoeducation:${(path.split(/^\/?([a-z]{2}-[a-z]{2}\/)?/)[2] ?? 'page').replace(
    /\//g,
    ':'
  )}`

  const l = 'legoeducation:'.length

  const index = pageName.slice(l).indexOf(':')

  let siteSection = pageName

  if (index > -1) {
    siteSection = pageName.slice(0, l + index)
  }

  return [siteSection, pageName]
}
